module.exports = __webpack_public_path__ + "static/poornaclinic-4bf5e47e40fe63df014a54aefa5db6a1.png";